import { render, staticRenderFns } from "./VentasListaCarritoEntregadasItem.vue?vue&type=template&id=a65d2eee&"
import script from "./VentasListaCarritoEntregadasItem.vue?vue&type=script&lang=js&"
export * from "./VentasListaCarritoEntregadasItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports